import { createRequest, RequestConfig } from '../../core/libs/api';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/app_subscribe',
};

export type NewPushSubscription = {
  personId: number;
  subscription: {
    endpoint: string;
    keys: { p256dh: string; auth: string };
  };
};

export const pushSubscriptionRequest = (subscription: NewPushSubscription) =>
  createRequest({
    url: config.url,
    body: JSON.stringify(subscription),
    method: config.method,
  });
